
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AuthModule from '@/store/auth.module'
import response from '@/model/response'
import messageModel from '@/model/message'
import user from '@/model/user'
import activaterequest from '@/model/requests/activaterequest'
import licenseresponse from '@/model/response/licenseresponse'
import message from '@/model/message'

export default defineComponent({
    setup() {
        const { t } = useI18n({ useScope: 'global' })

        const licenseType = ref<number | null>(null)
        const licenseCode = ref('')

        const loading = ref(false)
        const message = ref('')
        const successful = ref(false)

        const fullLicenseRegex = /^[A-Z0-9]{4}(-[A-Z0-9]{4}){3}$/

        const licensePresets: Record<number, string> = {
            14: '50TG-0000-0000-0000',
            15: '100T-0000-0000-0000',
            16: '500T-0000-0000-0000',
            17: '1KTT-0000-0000-0000',
            18: '25KT-0000-0000-0000',
            19: '5KTT-0000-0000-0000',
            20: '10KT-0000-0000-0000',
            21: 'FULL-0000-0000-0000'
        }

        const onLicenseTypeChange = (type: number) => {

            licenseCode.value = licensePresets[type] ?? ''

        }

        const licenseOptions = [
            { label: '50 tags', value: 14 },
            { label: '100 tags', value: 15 },
            { label: '500 tags', value: 16 },
            { label: '1000 tags', value: 17 },
            { label: '2500 tags', value: 18 },
            { label: '5000 tags', value: 19 },
            { label: '10000 tags', value: 20 },
            { label: 'Full', value: 21 }
        ]

        return {
            t,
            licenseType,
            licenseCode,
            licenseOptions,
            loading,
            message,
            successful,
            fullLicenseRegex,
            onLicenseTypeChange
        }
    },

    computed: {
        currentUser(): user {
            return AuthModule.currentUser
        }
    },

    mounted() {
        if (!this.currentUser) {
            this.$router.push('/login')
            return
        }
        this.loadLicense()
    },

    methods: {
        loadLicense() {
            this.loading = true

            AuthModule.getLicense().then(
                (resp: response) => {
                    if (resp.statusCodeValue === 200) {
                        const msg = (resp.body as message).message
                        const license: licenseresponse = JSON.parse(msg)

                        if (license && license.id >= 14) {
                            this.licenseType = license.id
                            this.licenseCode = license.number
                        }
                    }
                    this.loading = false
                },
                () => {
                    this.loading = false
                }
            )
        },

        handleActivate() {
            this.message = ''
            this.successful = false

            if (!this.fullLicenseRegex.test(this.licenseCode)) {
                this.message = this.t('activate.invalidcode')
                return
            }

            this.loading = true

            const request: activaterequest = {
                token: this.currentUser.accessToken,
                id: this.licenseType as number,
                code: this.licenseCode
            }

            AuthModule.Activate(request).then(
                (data: response) => {
                    this.message = (data.body as messageModel).message
                    this.successful = data.statusCodeValue === 200
                    this.loading = false
                    if (this.successful) this.loadLicense()
                },
                (error) => {
                    this.message =
                        error?.response?.data?.message ||
                        error.message ||
                        error.toString()
                    this.successful = false
                    this.loading = false
                }
            )
        },

        handleDeactivate() {
            this.message = ''
            this.successful = false
            this.loading = true

            const request: activaterequest = {
                token: this.currentUser.accessToken,
                id: this.licenseType as number,
                code: this.licenseCode
            }

            AuthModule.Deactivate(request).then(
                (data: response) => {
                    this.message = (data.body as messageModel).message
                    this.successful = data.statusCodeValue === 200
                    this.loading = false
                    if (this.successful) {
                        this.hasLicense = false
                        this.licenseCode = ''
                        this.licenseType = null
                    }
                },
                (error) => {
                    this.message =
                        error?.response?.data?.message ||
                        error.message ||
                        error.toString()
                    this.successful = false
                    this.loading = false
                }
            )
        }
    }
})
